import API_MAP from "./RouteCategory";

const normalize = (url = "") =>
  url.replace(/\/:[^/]+/g, "/:param");

export const resolveTransactionType = (endpoint) => {
  if (!endpoint) return { action: "UNKNOWN", entity: "UNKNOWN" };

  const normalizedEndpoint = normalize(endpoint);

  for (const [ACTION, entities] of Object.entries(API_MAP)) {
    for (const [ENTITY, paths] of Object.entries(entities)) {
      for (const path of paths) {
        if (normalize(path) === normalizedEndpoint) {
          return {
            action: ACTION,
            entity: ENTITY
          };
        }
      }
    }
  }

  return { action: "UNKNOWN", entity: "UNKNOWN" };
};
